import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/publications')({
  loader: () => {
    throw redirect({ to: '/publication/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
